/**
 * @file 开发者社区入口
 * @author WanZhongYun(wanzhongyun@baidu.com)
 */
import 'react-app-polyfill/ie9';
import 'react-app-polyfill/stable';
import 'location-origin';
import 'element-qsa-scope';
import React from 'react';
import ReactDOM from 'react-dom';
import CommunityRouter from './CommubityRouter';

import './style/style.less';

ReactDOM.render(<CommunityRouter />, document.getElementById('root'));